export default "__VITE_ASSET__ZNsL7YyJ__"